import { IconRenderer } from "../../../../helper/components/IconRenderer.js";
import { Checkbox } from "../../../checkbox/Checkbox.js";
import { Typography } from "../../../typography/Typography.js";
import styles from "./MultiSelectSearchItem.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MultiSelectSearchItem({
  item,
  onSelect
}) {
  return /*#__PURE__*/_jsx("div", {
    className: styles.listItem,
    children: /*#__PURE__*/_jsx(Checkbox, {
      classNames: styles.checkboxWrapper,
      checked: item.checked,
      onChange: e => onSelect(item.id, e.target.checked),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [item.icon && /*#__PURE__*/_jsx(IconRenderer, {
          icon: item.icon,
          size: "DEFAULT"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.label,
          children: [/*#__PURE__*/_jsx(Typography, {
            margin: false,
            variant: "p",
            children: item.title
          }), item.subtitle && /*#__PURE__*/_jsx(Typography, {
            margin: false,
            variant: "span",
            className: styles.subtitle,
            children: item.subtitle
          })]
        })]
      })
    })
  });
}